import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionAdminToListPops } from "../../actions/adminPopsActions";
import LoadingBox from "../../modules/shared/components/LoadingBox";
import MessageBox from "../../modules/shared/components/MessageBox";
import PopsBanner from "./PopBanner";
import useGetLimitedTimeDiscountInfo from "../../hooks/useGetLimitedTimeDiscountInfo";
import { getQueryFromUrl } from "../../libraries/ercLibrary";
// import calculateLimitedTimeDiscountValidity from "../../utils/calculateLimitedTimeDiscountValidity";

export default function PopsComponent(props) {
  const dispatch = useDispatch();
  const popPrice = getQueryFromUrl("popPrice");

  // PROPS COMING FROM App
  const { createdFingerPrint, visitTime, cartTotal } = props;

  // BRING IN POPS LIST FROM REDUX STORE
  const listPops = useSelector((state) => state.listPops);
  const { loading, error, popsList } = listPops;
  // DISPATCH ACTION TO LIST POPS
  useEffect(() => {
    dispatch(actionAdminToListPops());
  }, [dispatch]);

  const { isDiscountValid, remainingTime } = useGetLimitedTimeDiscountInfo(
    createdFingerPrint,
    createdFingerPrint,
    visitTime,
    visitTime,
  );

  // CHECK IF THERE IS DISCOUNT IN THE CARD
  const [hasDiscount, setHasDiscount] = useState(false);
  useEffect(() => {
    if (cartTotal) {
      const noDsicountAmount = cartTotal?.totalAmountWithoutDiscount ?? 0;
      const totalAmount = cartTotal?.totalAmount ?? 0;
      const surpriceDiscount = cartTotal?.surpriceDiscount ?? 0;

      setHasDiscount(noDsicountAmount - totalAmount - surpriceDiscount > 0);
    }
  }, [cartTotal]);

  return (
    <>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        popsList.map((pop, index) => {
          return (
            <PopsBanner
              key={index}
              pop={pop}
              popPrice={popPrice}
              isDiscountValid={isDiscountValid}
              remainingTime={remainingTime}
              hasDiscount={hasDiscount}
            />
          );
        })
      )}
    </>
  );
}
